export default __webpack_public_path__ + "static/media/svg-4.b4296e9d.svg";